import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBarsThree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bars-three, menu, list, hamburger"} maskId="square-filled-radius-0-stroke-1-IconBarsThree"><path fillRule="evenodd" clipRule="evenodd" d="M2 5H22V6H2V5ZM2 11.5H22V12.5H2V11.5ZM2 18H22V19H2V18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBarsThree;
